import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { localDataService } from '../../Services/localDataServices';
import { environment } from '../../../environments/environment';

declare var $: any;  //定义jquery
declare var async: any;
@Component({
  selector: 'index',
  providers: [localDataService],
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class indexComponent {

  constructor(
    private _router: Router,
  ) {

  }
  _coBizId: any = [];
  _code: any;
  _W0001 = false;
  _Y0005 = false;
  _S0001 = false;
  _S0002 = false;
  _Y0001 = false;
  _Y1111 = false;  // 装箱单识别 
  _W0004 = false;
  beiannum = 3
  ngOnInit() {
    //域名备案
    if (window.location.host.indexOf('autoport.com.cn') > -1) {
      this.beiannum = 3
    } else if (window.location.host.indexOf('baoguan001.com') > -1) {
      this.beiannum = 1
    } else if (window.location.host.indexOf('codeflagai.com') > -1) {
      this.beiannum = 2
    }
    if (sessionStorage.getItem("coBizId")) {
      this._coBizId = JSON.parse(sessionStorage.getItem("coBizId"));
    }
    for (let i = 0; i < this._coBizId.length; i++) {
      if (this._coBizId[i].code == 'W0001') {
        this._W0001 = true;
      }
      if (this._coBizId[i].code == 'Y0005') {
        this._Y0005 = true;
      }
      if (this._coBizId[i].code == 'S0001') {
        this._S0001 = true;
      }
      if (this._coBizId[i].code == 'S0002') {
        this._S0002 = true;
      }
      if (this._coBizId[i].code == 'Y0001') {
        this._Y0001 = true;
      }
      if (this._coBizId[i].code == 'Y1111') {
        this._Y1111 = true;
      }
      if (this._coBizId[i].code == 'W0004') {
        this._W0004 = true;
      }
    }
    let pthis = this;
    $('.uplodewj').on('dragover', function (event) {
      event.preventDefault();
      $(this).addClass("drag-border");

    }).on('dragleave', function (event) {
      event.preventDefault();
      $(this).removeClass("drag-border");
    }).on('drop', function (event) {
      event.preventDefault();
      var session_input = sessionStorage.getItem("perMi");
      if (session_input == '1') {
        $(".file-type").css("display", "none");
        var file = event.originalEvent.dataTransfer.files;
        pthis._code = $(event)[0].currentTarget.getAttribute("title");
        pthis.uploadFiles(file)
      } else {
        $('#loginModal').modal('show');
      }
    });

    //点击上传托书按钮
    $(".uplodewj").click(function () {
      let session_input = sessionStorage.getItem("perMi");
      if (session_input == '1') {
        $(".file-type").css("display", "none");
        $('.plfileheaderInput').click();

      } else {
        $('#loginModal').modal('show');
      }
    });


    //替换input
    $('.content-file').on("change", function () {
      var file = $(this)[0].files;
      pthis.uploadFiles(file)
    });
  }

  findKey() {
    for (let i = 0; i < this._coBizId.length; i++) {
      if (this._coBizId[i].code == this._code) {
        return this._coBizId[i].coBizId;
      }
    }
  }




  uploadFile:any
  //有点乱
  uploadFiles(file) {
    this.uploadFile = file
    var fileLength = file.length;
    if (!fileLength) return false;

    $(".loadFile-img").addClass("hide");

    if (fileLength === 1) {
      var fileType = this.fileValidate(file[0]);
      if (!fileType) return false;

      $(".upload-file-bottom-left").addClass(fileType);

      $(".upload-file-one").removeClass("hide");
      $(".upload-file-name").html(file[0].name);
      this.uploadAjax(file[0], 'token', 1)
    }
  }
  Reupload() {
    $(".upload-file-pre").html("0%");
    $("._single-progress-bar").css("width", "0%");
    this.uploadFiles(this.uploadFile)
  }
  closeUpload() {
    $('.content-file').val('')
    $(".upload-file-pre").html("0%");
    $("._single-progress-bar").css("width", "0%");
    $("._single-img-fail").addClass("hide");
    $("._single-state-success").addClass("hide");
    $("._single-filerep-submit").addClass("hide");
    $("._single-file-submit").addClass("hide");
    $(".upload-file-name").html('');
    $('.upload-file-one').addClass("hide")
  }
  //验证文件格式大小
  fileValidate(file) {
    var maxsize = 20 * 1024 * 1024;
    if (file.size > maxsize) return false;

    var fileType = file.type;

    var str = "word";
    if (fileType == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || fileType == "application/msword") {
      str = 'word';
    } else if (fileType == "image/jpeg") {
      str = 'jpg';
    } else if (fileType == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || fileType == "application/vnd.ms-excel.sheet.macroEnabled.12") {
      str = 'excel';
    } else if (fileType == "application/pdf") {
      str = 'pdf';
    }

    return str;
  }

  orderNo: any;
  uploadAjax(file, token, fileLength,) {
    $(".upload-file-content").html('')
    function createImg() {
      var dom = $('' +
        '<div mag-thumb="inner" mag-flow="inline" class="mag-eg-el1">' +
        '<img>' +
        '</div>');

      $(".upload-file-content").append(dom);
      dom.mag();

      return dom;
    }
    //单文件上传进度条
    function progressFunction(evt) {
      var loaded = evt.loaded;
      var tot = evt.total;
      var per = Math.floor(100 * loaded / tot);
      $(".upload-file-pre").html(per + "%");
      $("._single-progress-bar").css("width", per + "%");
    }




    if (!token) return false;


    var formData = new FormData();
    formData.append('file', file);

    let header = {
      CusAuthorization: sessionStorage.getItem("token"),
      orderOutNo: "docTS" + (new Date).getTime(),
      coBizId: this.findKey()
    }

    let pthis = this;
    $.ajax({
      url: "/coapi/files/upload",
      type: "post",
      data: formData,
      headers: header,
      cache: false,
      dataType: "json",
      processData: false,
      contentType: false,
      xhr: function () {
        var xhr = $.ajaxSettings.xhr();
        if (progressFunction && xhr.upload && fileLength === 1) {
          xhr.upload.addEventListener("progress", progressFunction, false);
          return xhr;
        } else {
          return xhr;
        }
      },
      success: function (data) {

        if (fileLength === 1) {
          if (data.status) {
            pthis.orderNo = data.obj;
            $("._single-img-fail").addClass("hide");
            $("._single-state-success").removeClass("hide").siblings().addClass("hide");

            $("._single-file-token").val(data.doc_token);
            $("._single-file-doc-format").val(data.doc_format);
            $("._single-file-doc-type").val(data.doc_type);
            $("._single-file-img-path").val(data.img_path);
            $("._single-file-doc-name").val(data.fileName);

            $("._single-filerep-submit").addClass("hide");
            $("._single-file-submit").removeClass("hide");

            //var path = "/Home/File/wFile" + "?fullPath=" + data.img_path;

            if (data.doc_type === "jpg") {
              var dom = createImg();
              // dom.find("img").attr("src", path);
            } else { }

          } else {
            $("._single-img-fail").removeClass("hide");
            $("._single-state-fail").removeClass("hide").siblings().addClass("hide");
            $("._single-filerep-submit").removeClass("hide")
          }
        }
      },
      err: function () {
        if (fileLength === 1) {
          $("._single-img-fail").removeClass("hide");
          $("._single-state-fail").removeClass("hide").siblings().addClass("hide");
        }
      }
    });
  }


  comm() {
    if (this._code == 'W0001') {
      // this._router.navigate(['imgUpdata', this.orderNo]);
      window.open(`${environment.detailsToPath}/identifyDetails/${this.orderNo}/${sessionStorage.getItem("token")}`)
      $(".upload-file-one").addClass("hide");
    } else if (this._code == 'Y0005') {
      this._router.navigate(['shoppingOrder', this.orderNo]);
    } else if (this._code == 'S0001') {
      this._router.navigate(['containerNumber', this.orderNo]);
    } else if (this._code == 'S0002') {
      this._router.navigate(['sealNumber', this.orderNo]);
    } else if (this._code == 'W0004') {
      this._router.navigate(['historyList']);
    }else if (this._code == 'Y1111') {
      this._router.navigate(['historyList']);
    }

  }

  djzc(code) {
    this._code = code;
  }

}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/index/index.component.ts